import { ProductPreviewType } from "~/types/shop/ProductPreviewType";
import { RuntimeConfig } from "nuxt/schema";
import { autoDetectAffiliateUrlFormatter } from "~/utils/formatters/affiliate.url.formatter";

export const ProductPreviewEntity = function (data: any, config: RuntimeConfig): ProductPreviewType {
    return {
        title: data?.attributes?.title,
        subTitle: data?.attributes?.sub_title,
        slug: data?.attributes?.slug,
        price: data?.attributes?.price,
        oldPrice: data?.attributes?.old_price,
        image: config.public.ssrMediaBaseUrl + data?.attributes?.images?.data[0]?.attributes?.url,
        buyUrl: autoDetectAffiliateUrlFormatter(data?.attributes?.buy_url, config),
        url: `/shop/product-${data?.attributes?.slug}`,
    };
};